import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import {
  hasOnlyNumbers,
  isValidSiret,
  hasOnlyLatinChars,
  getValidationClass,
  hasOnlyNumbersOrDecimal,
  hasNoNumbers
} from '@/utils/formUtils';
import FormError from '../FormError';
import { ERROR_TYPE, FIELD_TYPE, INTRACOM_NUMBER_REGEX } from '@/constants/form';

const DEFAULT_ROWS = 4;

export const TextField = ({
  id, name, type, rows, className, validators = [], isRequired, country, ...rest
}) => {
  const { register, formState, formState: { errors }, clearErrors } = useFormContext();

  const isIntracomNumberValidated = async (intracomNumber) => {
    if (intracomNumber && !intracomNumber.match(INTRACOM_NUMBER_REGEX[country])) {
      return false;
    }
    clearErrors(name);
    return true;
  };

  const validate = Object.fromEntries([
    validators.includes(ERROR_TYPE.INTRACOM_NUMBER) && [ERROR_TYPE.INTRACOM_NUMBER, isIntracomNumberValidated],
    validators.includes(ERROR_TYPE.SIRET) && [ERROR_TYPE.SIRET, isValidSiret],
    validators.includes(ERROR_TYPE.ONLY_NUMBERS) && [ERROR_TYPE.ONLY_NUMBERS, hasOnlyNumbers],
    validators.includes(ERROR_TYPE.ONLY_NUMBERS_OR_DECIMALS) && [ERROR_TYPE.ONLY_NUMBERS_OR_DECIMALS, hasOnlyNumbersOrDecimal],
    validators.includes(ERROR_TYPE.ONLY_LATIN_CHARS) && [ERROR_TYPE.ONLY_LATIN_CHARS, hasOnlyLatinChars],
    validators.includes(ERROR_TYPE.NO_NUMBER) && [ERROR_TYPE.NO_NUMBER, hasNoNumbers]
  ].filter(Boolean));

  const InputElement = type === FIELD_TYPE.TEXT_AREA ? 'textarea' : 'input';
  const inputProps = {
    id,
    rbf: `input${id ? '-' + id : ''}`,
    className: [
      'form-control',
      className,
      getValidationClass(name, formState)
    ].filter(Boolean).join(' '),
    name,
    ...register(name, { required: isRequired, validate }),
    ...rest
  };

  if (type === FIELD_TYPE.TEXT_AREA) {
    inputProps.rbf = `textarea${id ? '-' + id : ''}`;
    inputProps.rows = rows || DEFAULT_ROWS;
  }

  return (
    <>
      <InputElement {...inputProps} type={type !== FIELD_TYPE.TEXT_AREA ? type : null} />
      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

TextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
  validators: PropTypes.arrayOf(PropTypes.string),
  isRequired: PropTypes.bool
};

export default TextField;
